// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fKT2J","colBig":"styles_colBig__2ue4H","colSmall":"styles_colSmall__31_Ag","shopifyNameWrapper":"styles_shopifyNameWrapper__18Nwx"};